import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';

export default function FacilitatorNotes({ sessionId }) {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');
  const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saving' | 'saved'

  useEffect(() => {
    api.notes.get(sessionId).then(d => setText(d.notes || '')).catch(() => {});
  }, [sessionId]);

  const handleBlur = async () => {
    setSaveState('saving');
    try {
      await api.notes.save(sessionId, text);
      setSaveState('saved');
      setTimeout(() => setSaveState('idle'), 2000);
    } catch {
      setSaveState('idle');
    }
  };

  return (
    <>
      {/* Toggle button */}
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          position: 'fixed', right: open ? 350 : 0, top: '50%',
          transform: 'translateY(-50%) rotate(-90deg)',
          transformOrigin: 'right center',
          zIndex: 501, background: 'var(--primary)', color: 'white',
          border: 'none', padding: '6px 14px', cursor: 'pointer',
          borderRadius: '4px 4px 0 0', fontSize: 12, whiteSpace: 'nowrap',
          transition: 'right 0.2s'
        }}
      >
        📝 Notes
      </button>

      {/* Sidebar panel */}
      {open && (
        <div style={{
          position: 'fixed', right: 0, top: 0, height: '100vh', width: 350,
          background: 'var(--bg-elevated)', borderLeft: '1px solid var(--border)',
          zIndex: 500, padding: 16, display: 'flex', flexDirection: 'column',
          boxShadow: '-4px 0 16px rgba(0,0,0,0.15)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
            <span style={{ fontWeight: 700, fontSize: 14 }}>📝 Facilitator Notes</span>
            <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: 'var(--text-muted)' }}>×</button>
          </div>
          <p style={{ fontSize: 11, color: 'var(--text-muted)', margin: '0 0 12px' }}>Private — only you can see this</p>
          <textarea
            value={text}
            onChange={e => setText(e.target.value)}
            onBlur={handleBlur}
            placeholder="Jot down talking points, observations, follow-ups..."
            style={{
              flex: 1, width: '100%', resize: 'none', fontFamily: 'inherit',
              fontSize: 13, lineHeight: 1.6, background: 'var(--bg)',
              border: '1px solid var(--border)', borderRadius: 4,
              padding: 8, color: 'var(--text)', boxSizing: 'border-box'
            }}
          />
          <div style={{ marginTop: 8, fontSize: 11, color: 'var(--text-muted)', minHeight: 16 }}>
            {saveState === 'saving' && 'Saving...'}
            {saveState === 'saved' && '✓ Saved'}
          </div>
        </div>
      )}
    </>
  );
}
